import SiteMessageForm from 'pages/shared/SiteMessageForm'

import { SinglePanePage } from 'styles/shared'

const AddSiteMessage = () => (
  <SinglePanePage>
    <SiteMessageForm
      title="New Site Message"
      validatedSaveType="create"
    />
  </SinglePanePage>
)

export default AddSiteMessage
